import { observer } from "mobx-react";
import { useState } from "react";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { TriggerArrow } from "../../../../../components/collapsible/trigger-arrow/trigger-arrow";
import "./online-inventory-addresses-list.scss";
import { IPlatformLocation } from "../../../../return-methods/return-method-types";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { RadioButton } from "../../../../../components/inputs/radio-button/radio-button";
import useUuid from "../../../../../hooks/uuid-hook";


interface IProps {
    locationsList: IPlatformLocation[];
    onSelect: (platformLocation: IPlatformLocation) => void;
    selectedId: string | undefined | null;
}
const OnlineInventoryAddressesList: React.FC<IProps> = observer(({ locationsList, selectedId, onSelect }: IProps) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';
    const uuid = useUuid();
    const [showAll, setShowALl] = useState(false);

    const OnlineInventoryAddressesToShow = showAll ? locationsList : locationsList.slice(0, 8);


    return(
        <div className="addresses-content">
            <div className="addresses-items">
                {OnlineInventoryAddressesToShow.map((location, index) => {
                        const addressParts = [
                          location.line_1,
                          location.line_2,
                          location.city,
                          location.state,
                          location.country,
                          location.postal_code,
                        ]
                          .filter(Boolean)
                          .join(", ");
                    return ( 
                        <div key={index} className="address">
                            <div className="address-item" onClick={() => onSelect(location)}>
                                <RadioButton name={`inventory_address_radio_button_${uuid}`} checked={selectedId === location.location_id} />
                                <div className="address-item-text">
                                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{location.name}</FontBody2>
                                    <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                                        {addressParts}
                                        {location.phone && <div>{location.phone}</div>}
                                    </FontBody2>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            {!showAll && locationsList.length > 8 &&
                <div className="show-all-addresses" onClick={() => setShowALl(!showAll)}>
                    <FontBody2>{`${getTranslation("SHOW_ALL_ADDRESSES",scope)} (${locationsList.length})`}</FontBody2>
                    <TriggerArrow isExpanded={showAll} />
                </div>
            }
        </div>
    );
});

export default OnlineInventoryAddressesList;